import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "document-updated-block white flex flex-column" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "flex flex-align-end flex-justify-center flex-wrap full-height" }
const _hoisted_4 = {
  key: 0,
  class: "counter mr-05 ml-05"
}
const _hoisted_5 = { class: "flex flex-align-center mr-05 ml-05" }
const _hoisted_6 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "top flex flex-column flex-align-center flex-justify-center",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDocumentType && _ctx.openDocumentType(...args)))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["mb-05", _ctx.getIcon])
      }, null, 2),
      _createElementVNode("b", {
        textContent: _toDisplayString(_ctx.$t(_ctx.getTitle))
      }, null, 8, _hoisted_2)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("button", {
      class: "footer full-width flex-grow-1",
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDocumentOverview && _ctx.openDocumentOverview(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        (this.summary.documentType !== _ctx.documentTypes.Certificates)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(this.summary.count), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("b", {
            class: "roboto-slab",
            textContent: _toDisplayString(_ctx.$t(this.summary.documentType === _ctx.documentTypes.Certificates ? "DASHBOARD.DOCUMENTS" : "DASHBOARD.NEW_DOCUMENTS"))
          }, null, 8, _hoisted_6),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icons8-forward" }, null, -1))
        ])
      ])
    ])
  ]))
}